import React from "react";
import { Compass } from "lucide-react";
import { Toaster } from "sonner";

// Shared centered card layout for all unauthenticated auth screens.
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen w-screen flex items-center justify-center bg-slate-950 text-slate-100 font-body p-4 canvas-dot-grid">
      <Toaster theme="dark" position="top-right" />
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-lg bg-gradient-to-br from-amber-500 to-amber-700 flex items-center justify-center gold-glow">
            <Compass className="h-6 w-6 text-slate-950" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-display text-xl font-semibold tracking-tight leading-none">Vaastu Just 4 U</div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mt-1">Floor Plan Sector Analyzer</div>
          </div>
        </div>

        <div className="bg-slate-900/80 backdrop-blur-md border border-slate-800 rounded-xl p-7 shadow-2xl">
          <h1 className="font-display text-2xl font-semibold mb-1">{title}</h1>
          {subtitle && <p className="text-sm text-slate-400 mb-6">{subtitle}</p>}
          {children}
          {footer}
        </div>
      </div>
    </div>
  );
}
